import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  groupTypeSelector,
  reportBookTypeSelector,
} from './store/selectors';
import {
  reportingCurrencyCodeSelector,
  periodOrCurrentSelector,
} from '../../shared/store/selectors';
import {
  fetchDrillDetail,
  selectEntryForDrillDetail,
} from './store/actions';

class DrillDetailLink extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
    ]).isRequired,
    reportLineType: PropTypes.string.isRequired,
    groupItem: PropTypes.string.isRequired,
    columnTitle: PropTypes.string.isRequired,

    reportingCurrency: PropTypes.string.isRequired,
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
      taxYear: PropTypes.string.isRequired,
    }).isRequired,
    reportBookType: PropTypes.string.isRequired,
    groupType: PropTypes.string.isRequired,
    fetchDrillDetail: PropTypes.func.isRequired,
    selectEntryForDrillDetail: PropTypes.func.isRequired,
    taxCurrency: PropTypes.string,
    funcCurrency: PropTypes.string,
    useHistorical: PropTypes.bool,
    detailAggregationType: PropTypes.string.isRequired,
    countryTaxType: PropTypes.string,
    cellToElevateSelector: PropTypes.string,
  };

  handleClick = event => {
    event.preventDefault();
    const {
      reportLineType,
      groupItem,
      columnTitle,

      period,
      reportingCurrency,
      reportBookType,
      groupType,

      fetchDrillDetail,
      selectEntryForDrillDetail,
      taxCurrency,
      funcCurrency,
      useHistorical,
      detailAggregationType,
      countryTaxType,
      cellToElevateSelector,
    } = this.props;

    fetchDrillDetail({
      useHistorical,
      periodName: period.name,
      reportType: reportBookType,
      reportingCurrency,
      groupType,
      reportLineType,
      groupItem,
      taxCurrency,
      funcCurrency,
      detailAggregationType,
      countryTaxType,
    });

    selectEntryForDrillDetail({
      columnTitle,
      groupItem,
      reportLineType,
      cellToElevateSelector,
    });
  };

  render() {
    return (
      <a href="#details" data-tip="" data-for="taxExpenseDetails" onClick={this.handleClick}>
        {this.props.children}
      </a>
    );
  }
}

function mapStateToProps(state) {
  return {
    reportingCurrency: reportingCurrencyCodeSelector(state),
    period: periodOrCurrentSelector(state),
    reportBookType: reportBookTypeSelector(state),
    groupType: groupTypeSelector(state),
  };
}

export default connect(
  mapStateToProps,
  {
    fetchDrillDetail,
    selectEntryForDrillDetail,
  }
)(DrillDetailLink);
